import {useLocation} from '@tanstack/react-router'
import {useMemo} from 'react'

export function useAnyFiltersApplied() {
  const location = useLocation()

  return useMemo(() => {
    const filters = Object.values(location.search.filters ?? {})

    return filters.some(f => {
      if (Array.isArray(f)) return Boolean(f.length)
      return Boolean(f)
    })
  }, [location.search.filters])
}
